module.exports = __webpack_public_path__ + "static/img/buy_help.c726960.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/buy_help.png
// module id = sPCo
// module chunks = 18